module.exports = "pegasus_template/assets/f-icon3.png";